import {
  EmailIconButton,
  NoteIconButton,
  PhoneIconButton,
  SmsIconButton,
} from "../../../../components/buttons";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  Alert,
} from "@mui/material";
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";
import { AddButton } from "../../../../components/buttons";
import {
  getCaseCommunicationHistory,
  getInstructionTaskAnswerDetails,
  getMailListThunk,
  getNotesAndDocumentById,
  readImage,
} from "../../../../thunks/instruction";
import {
  downloadClientNotesDocument,
  downloadNotesDocument,
  getColorCodeForQc,
} from "../../../../utils/util";
import AddNotesAndDocument from "../AddNotesAndDocument";
import DocumentsByType from "../DocumentsByType";
import EmailBox from "../EmailBox";
import IndividualTask from "../IndividualTaskList";
import UpdateTaskAnswerDialog from "../UpdateTaskAnswerDialog";
import { getPinnedClientCommunication } from "../../../../thunks/client";
import { CopyAll } from "@mui/icons-material";
import { showSnackbar } from "../../../../slice/snackbarSlice";
import PushPinIcon from "@mui/icons-material/PushPin";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";

import {
  INBOUND__CLIENT_PARSE_URL,
  INBOUND_PARSE_URL,
  NOTIFICATION_MESSAGE,
  USER_ROLE,
} from "../../../../utils/constant";
import SmsDialog from "../../../client/components/SmsDialog";
import PhoneDialog from "../../../client/components/PhoneDialog";
import TransferClientEmailDialog from "../../../client/components/TransferClientEmailDialog";
import FullEmailDialog from "../../../client/components/FullEmailDialog";
import moment from "moment";
import EmailWithStatus from "../EmailWithStatus";
import SingleNoteContainer from "../SingleNoteContainer";
import InstructionSingleEmail from "../InstructionSingleEmail";
import { downloadFileThunk } from "../../../../thunks/downloadFileThunk";
const DocNotesEmailForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loader = useRef(null);
  const params = useParams();

  const userDetails = useSelector((state) => state?.auth?.currentUser);
  const { taskType, instructionId, taskId } = useSelector(
    (state) => state?.task?.TaskTypeData || {}
  );
  const instructionData = useSelector(
    (state) => state.instruction.instructionDashboardData
  );
  const isDeceasedSingleClient =
    !instructionData?.InstructionClients?.[0]?.riskAlert?.deceased;
  const isDeceasedClient1 =
    !instructionData?.InstructionClients?.[0]?.riskAlert?.deceased &&
    !!instructionData?.InstructionClients?.[0]?.email?.trim();
  const isDeceasedClient2 =
    !instructionData?.InstructionClients?.[1]?.riskAlert?.deceased &&
    !!instructionData?.InstructionClients?.[1]?.email?.trim();
  let isDeceased = instructionData?.isJoint
    ? isDeceasedClient1 || isDeceasedClient2
    : isDeceasedSingleClient;
  // email config
  // const mailReceivers = useMemo(() => {
  //   return (
  //     instructionData?.InstructionClients?.filter((obj) => obj?.email)?.map(
  //       (obj) => ({ label: obj?.email, value: obj?.email })
  //     ) || []
  //   );
  // }, [instructionData?.InstructionClients]);
  // email config for deceased clients
  const mailReceivers = useMemo(() => {
    return (
      instructionData?.InstructionClients?.filter(
        (obj) => obj?.email?.trim().length > 0 && !obj?.riskAlert?.deceased
      )?.map((obj) => ({ label: obj?.email, value: obj?.email })) || []
    );
  }, [instructionData?.InstructionClients]);

  const [isLoader, setLoader] = useState(false);
  const [expanded, setExpanded] = useState({
    isDocument: false,
    isNotesAndRemarks: false,
    isEmail: false,
    isCommunication: false,
  });
  const [notesAndDocumentsData, setNotesAndDocumentsData] = useState([]);
  const [pinnedNotesAndDocumentsData, setPinnedNotesAndDocumentsData] =
    useState([]);
  const [openNotesAndDocuments, setOpenNotesAndDocuments] = useState(false);
  const [openMailbox, setOpenMailbox] = useState(false);
  const [isIndividualTask, setIsIndividualTask] = useState(false);
  const [isDocumentsOpen, setDocumentsOpen] = useState(false);
  const [updateTaskAnswerDialog, setUpdateTaskAnswerDialog] = useState(false);
  const [selectedTaskData, setSelectedTaskData] = useState(null);
  const [selectedAnswerData, setSelectedAnswerData] = useState(null);
  const [isViewOnly, setViewOnly] = useState(false);
  const [clientData, setClientData] = useState([]);
  const [showPhoneDialog, setShowPhoneDialog] = useState(false);
  const [showSmsDialog, setShowSmsDialog] = useState(false);
  const [communicationView, setCommunicationView] = useState(null);
  const [caseCommunication, setCaseCommunication] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [scrollPage, setScrollPage] = useState(1);
  const [showLinkCommunicationDialog, setShowLinkCommunicationDialog] =
    useState(false);
  const [selectedDataForLinking, setSelectedDataForLinking] = useState(null);

  // Get sender email
  const sender = userDetails?.email || null;

  /* Method to handle accordion changes */
  const handleAccordionChange = useCallback(
    (event, key) => {
      const updatedExpanded = Object.keys(expanded).reduce(
        (acc, accordionKey) => {
          acc[accordionKey] = accordionKey === key ? event : false;
          return acc;
        },
        {}
      );

      setExpanded(updatedExpanded);

      if (event && key === "isNotesAndRemarks") {
        getNotesAndDocumentsData();
        getClients();
      } else if (event && key === "isEmail") {
        getInstructionEmails();
      } else if (event && key === "isCommunication") {
        setCommunicationView(null);
      }
    },
    [expanded]
  );

  /* Method to get notes and documents data */
  const getNotesAndDocumentsData = useCallback(async () => {
    if (!instructionData?.id) return;

    setLoader(true);
    try {
      const response = await dispatch(
        getNotesAndDocumentById(instructionData.id)
      ).unwrap();
      setNotesAndDocumentsData(response || []);
    } catch (error) {
      console.error("Error fetching notes and documents:", error);
      setNotesAndDocumentsData([]);
    } finally {
      setLoader(false);
    }
  }, [dispatch, instructionData?.id]);

  /* Method to get pinned notes and documents data */
  const getPinnedNotesAndDocumentsData = useCallback(async () => {
    if (!instructionData?.id) return;

    setLoader(true);
    try {
      const response = await dispatch(
        getPinnedClientCommunication({
          id: instructionData.id,
          regardingType: "notes",
        })
      ).unwrap();
      setPinnedNotesAndDocumentsData(response || []);
    } catch (error) {
      console.error("Error fetching pinned notes and documents:", error);
      setPinnedNotesAndDocumentsData([]);
    } finally {
      setLoader(false);
    }
  }, [dispatch, instructionData?.id]);

  /* Method to get instruction emails */
  const getInstructionEmails = useCallback(async () => {
    if (!instructionData?.id) return;

    setLoader(true);
    try {
      await dispatch(
        getMailListThunk({
          params: { instructionId: instructionData.id },
        })
      ).unwrap();
    } catch (error) {
      console.error("Error fetching instruction emails:", error);
    } finally {
      setLoader(false);
    }
  }, [dispatch, instructionData?.id]);

  /* Success Method to create note */
  const handleSuccessCreateNote = useCallback(() => {
    getNotesAndDocumentsData();
  }, [getNotesAndDocumentsData]);

  /* Method to handle individual task click */
  const handleClickIndividualTask = useCallback(() => {
    setIsIndividualTask(!isIndividualTask);
  }, []);

  const openUpdateTaskAnswerDialog = useCallback(
    (answer, data, isIndividualTask) => {
      setSelectedTaskData({ ...data, isIndividualTask });
      setSelectedAnswerData(answer);
      setUpdateTaskAnswerDialog(true);
    },
    []
  );

  // Method to view task comments
  const viewTaskComment = useCallback((data) => {
    setSelectedTaskData({ ...data, isIndividualTask: true });
    setViewOnly(true);
    setUpdateTaskAnswerDialog(true);
  }, []);

  // Method to open Document dialog
  const handleClickOpenDocument = useCallback(() => {
    setDocumentsOpen(true);
  }, []);

  // Handle communication icon clicks
  const handleCommunicationClick = useCallback(
    (type) => {
      setCommunicationView(type);

      if (type === "email") {
        getInstructionEmails();
      } else if (type === "notes") {
        getNotesAndDocumentsData();
        getClients();
      }
    },
    [getInstructionEmails, getNotesAndDocumentsData]
  );

  // merge instruction and client pinned notes and sort by created at date
  const sortedNotesAndDocumentsData = useMemo(() => {
    return [...notesAndDocumentsData, ...pinnedNotesAndDocumentsData].sort(
      (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
    );
  }, [notesAndDocumentsData, pinnedNotesAndDocumentsData]);

  /* Method to get Clients details by passing instruction ID */
  const getClients = useCallback(async () => {
    if (!instructionData?.id) return;

    try {
      const response = await dispatch(
        getInstructionTaskAnswerDetails(instructionData.id)
      ).unwrap();
      setClientData(response || []);
    } catch (error) {
      console.error("Error fetching clients:", error);
      setClientData([]);
    }
  }, [dispatch, instructionData?.id]);

  const handleGetCaseCommunication = useCallback(async () => {
    if (!params?.id) return;

    setLoader(true);
    try {
      const response = await dispatch(
        getCaseCommunicationHistory({
          id: params.id,
          query: {
            page: scrollPage,
          },
        })
      ).unwrap();

      if (response?.activitiesWithRegardingData?.length > 0) {
        setCaseCommunication((prev) => {
          if (scrollPage === 1) {
            setHasMore(
              response.activitieCount >
                response.activitiesWithRegardingData.length
            );
            return response.activitiesWithRegardingData;
          } else {
            const temp = [...prev, ...response.activitiesWithRegardingData];
            setHasMore(response.activitieCount > temp.length);
            return temp;
          }
        });
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching case communication:", error);
    } finally {
      setLoader(false);
    }
  }, [dispatch, params?.id, scrollPage]);

  const emailBccLink = useMemo(
    () => `instruction+${instructionData?.id}${INBOUND_PARSE_URL}`,
    [instructionData?.id]
  );

  const copyBccLink = useCallback(() => {
    navigator?.clipboard
      .writeText(emailBccLink)
      .then(() => {
        dispatch(
          showSnackbar({
            message: NOTIFICATION_MESSAGE?.LINK_COPY_SUCCESS,
            severity: "success",
          })
        );
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: "Unable to copy text to clipboard",
            severity: "error",
          })
        );
        console.error("Unable to copy text to clipboard", err);
      });
  }, [dispatch, emailBccLink]);

  // Effects
  useEffect(() => {
    if (taskType) {
      setIsIndividualTask(true);
    }
  }, [taskType]);

  useEffect(() => {
    if (instructionData?.id) {
      getClients();
      getPinnedNotesAndDocumentsData();
    }
  }, [instructionData?.id, getClients, getPinnedNotesAndDocumentsData]);

  useEffect(() => {
    handleGetCaseCommunication();
  }, [handleGetCaseCommunication, scrollPage]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setScrollPage((prev) => prev + 1);
        }
      },
      { threshold: 1 }
    );

    if (loader?.current) {
      observer?.observe(loader?.current);
    }

    return () => {
      if (loader?.current) {
        observer?.unobserve(loader?.current);
      }
    };
  }, []);

  return (
    <>
      {/* Loader Component */}
      {isLoader && <Loader />}

      {/* Dialog for notes & documents */}
      {openNotesAndDocuments && (
        <AddNotesAndDocument
          open={openNotesAndDocuments}
          handleClose={() => setOpenNotesAndDocuments(false)}
          instructionId={instructionData?.id}
          handleSuccessCreateNote={handleSuccessCreateNote}
          clientData={clientData}
          handleGetCaseCommunication={handleGetCaseCommunication}
        />
      )}

      {/* Dialog for Individual Task List */}
      {isIndividualTask && (
        <IndividualTask
          open={isIndividualTask}
          taskType={taskType}
          taskId={taskId}
          handleClose={() => setIsIndividualTask(false)}
          instructionId={taskType ? instructionId : instructionData?.id}
          openUpdateTaskAnswerDialog={openUpdateTaskAnswerDialog}
          viewTaskComment={viewTaskComment}
        />
      )}

      {/* Dialog for Update task Answers */}
      {updateTaskAnswerDialog && (
        <UpdateTaskAnswerDialog
          open={updateTaskAnswerDialog}
          handleClose={() => {
            setUpdateTaskAnswerDialog(false);
            setViewOnly(false);
          }}
          selectedAnswer={selectedAnswerData}
          selectedTask={selectedTaskData}
          instructionId={instructionData?.id}
          isViewOnly={isViewOnly}
        />
      )}

      {/* Dialog for Document */}
      {isDocumentsOpen && (
        <DocumentsByType
          open={isDocumentsOpen}
          handleClose={() => setDocumentsOpen(false)}
          instructionId={instructionData?.id}
          clientData={clientData}
        />
      )}

      {/* QC Accuracy section */}
      {instructionData?.InstructionQcRatingHistory?.colour && (
        <Grid item xs={12} display="flex" gap={4} m={2}>
          <Typography className="serif_display_regular_18 dark_grey">
            QC Accuracy
          </Typography>
          <Typography
            className="normal_normal_16_Manrope"
            style={{
              color: getColorCodeForQc(
                instructionData.InstructionQcRatingHistory.colour
              ),
            }}
          >
            {instructionData.InstructionQcRatingHistory.colour || "NA"}
          </Typography>
        </Grid>
      )}

      {/* Send email dialog */}
      {openMailbox && (
        <EmailBox
          open={openMailbox}
          onClose={() => setOpenMailbox(false)}
          emailConfigData={{
            from: sender,
            to: mailReceivers,
          }}
          userDetails={userDetails}
          instructionId={instructionData?.id}
          instructionData={instructionData}
          clientData={clientData}
          handleGetCaseCommunication={handleGetCaseCommunication}
        />
      )}

      {/* Dialog for phone */}
      {showPhoneDialog && (
        <PhoneDialog
          open={showPhoneDialog}
          handleClose={() => setShowPhoneDialog(false)}
        />
      )}

      {/* Dialog for sms */}
      {showSmsDialog && (
        <SmsDialog
          open={showSmsDialog}
          handleClose={() => setShowSmsDialog(false)}
        />
      )}

      {/* Accordion for Documents Section */}
      <Grid item xs={12}>
        <Accordion
          fullWidth
          className="dashboard__accordion"
          expanded={isDocumentsOpen}
          onClick={handleClickOpenDocument}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography
              className="serif_display_regular_18"
              style={{ color: "black" }}
            >
              Documents
            </Typography>
          </AccordionSummary>
        </Accordion>
      </Grid>

      {/* Section for instruction forms redirect */}
      <Grid item xs={12}>
        <Accordion
          fullWidth
          className="dashboard__accordion"
          onClick={() =>
            navigate(`/app/instructions/forms/${instructionData?.id}`)
          }
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
          >
            <Typography className="serif_display_regular_18 dark_grey">
              Forms
            </Typography>
          </AccordionSummary>
        </Accordion>
      </Grid>

      {/* Generic Task section */}
      <Grid item xs={12}>
        <Accordion
          fullWidth
          className="dashboard__accordion"
          expanded={isIndividualTask}
          onClick={handleClickIndividualTask}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
          >
            <Typography className="serif_display_regular_18 dark_grey">
              Tasks
            </Typography>
          </AccordionSummary>
        </Accordion>
      </Grid>

      {/* Communication section */}
      <Grid item xs={12}>
        <Accordion
          className="dashboard__accordion"
          onChange={() =>
            handleAccordionChange(!expanded?.isCommunication, "isCommunication")
          }
          expanded={expanded?.isCommunication}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="communication-content"
          >
            <Typography className="serif_display_regular_18 dark_grey">
              Communication
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            border={0}
            sx={{ height: "70vh", flexGrow: 1, overflowY: "auto" }}
          >
            {/* Communication Icons */}
            <Grid border={0}>
              <Box display={"flex"} justifyContent={"center"} gap={1.5}>
                {/* Email */}
                <Tooltip title="email">
                  <Grid>
                    <EmailIconButton
                      onClick={() => setOpenMailbox(true)}
                      size="large"
                      disabled={!isDeceased}
                    />
                  </Grid>
                </Tooltip>

                {/* Notes */}
                <Tooltip title="note">
                  <Grid>
                    <NoteIconButton
                      onClick={() => setOpenNotesAndDocuments(true)}
                      size="large"
                    />
                  </Grid>
                </Tooltip>

                {/* Phone */}
                <Tooltip title="phone">
                  <Grid>
                    <PhoneIconButton
                      onClick={() => setShowPhoneDialog(true)}
                      size="large"
                      disabled={!isDeceased}
                    />
                  </Grid>
                </Tooltip>

                {/* SMS */}
                <Tooltip title="sms">
                  <Grid>
                    <SmsIconButton
                      onClick={() => {
                        setShowSmsDialog(true);
                      }}
                      size="large"
                      disabled={!isDeceased}
                    />
                  </Grid>
                </Tooltip>

                {/* Copy BCC Link */}
                <Tooltip title="Copy link to send email" placement="top">
                  <IconButton onClick={copyBccLink}>
                    <CopyAll fontSize="large" />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>

            <Grid mt={2}>
              {caseCommunication?.map((item, itemIndex, items) => (
                <React.Fragment key={item?.id}>
                  {item?.html ? (
                    <SingleEmailView
                      data={item}
                      dataIndex={itemIndex}
                      clientData={clientData}
                      setShowLinkCommunicationDialog={
                        setShowLinkCommunicationDialog
                      }
                      setSelectedDataForLinking={setSelectedDataForLinking}
                    />
                  ) : (
                    <SingleNoteView
                      d={item}
                      index={itemIndex}
                      clientData={clientData}
                      instructionId={instructionData?.id}
                      setShowLinkCommunicationDialog={
                        setShowLinkCommunicationDialog
                      }
                      setSelectedDataForLinking={setSelectedDataForLinking}
                    />
                  )}
                  {itemIndex !== items?.length - 1 && (
                    <Divider
                      sx={{
                        marginY: "1rem",
                        marginX: "1rem",
                        border: "0.5px solid lightgrey",
                      }}
                    />
                  )}
                </React.Fragment>
              ))}

              {/* Infinite Scroll Loader */}
              {hasMore && (
                <div
                  ref={loader}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100px",
                    textAlign: "center",
                  }}
                >
                  <Typography>Loading more items...</Typography>
                </div>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default DocNotesEmailForm;

const SingleEmailView = ({ data, clientData }) => {
  const userDetails = useSelector((state) => state?.auth?.currentUser);
  const [showFullEmail, setShowFullEmail] = useState(false);
  const [isEmailTransfer, setIsEmailTransfer] = useState(false);
  const handleClickEmailTransper = (data) => {
    setIsEmailTransfer(true);
  };
  let isPinned = Boolean(data?.leadClientId && data?.leadClientId !== null);
  return (
    <>
      {isEmailTransfer && (
        <TransferClientEmailDialog
          open={isEmailTransfer}
          onClose={() => {
            setIsEmailTransfer(false);
          }}
          selectedEmailId={data?.id}
        />
      )}

      {showFullEmail ? (
        <InstructionSingleEmail
          emailData={data}
          showFullEmail={showFullEmail}
          setShowFullEmail={() => setShowFullEmail(false)}
          clientData={clientData}
          isClientEmail={false}
        />
      ) : null}
      <div>
        <Grid item sx={{ paddingTop: "0 !important", mb: 2 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography className="normal_normal_600_14_Manrope green">
              From{" "}
            </Typography>
            {isPinned ? (
              <Tooltip title="This is a pinned email of client">
                <PushPinIcon
                  size="small"
                  color="action"
                  sx={{ color: "#00ce3f", fontSize: "18px" }}
                />
              </Tooltip>
            ) : null}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              className="normal_normal_600_14_Manrope dark_grey"
              style={{
                flexGrow: 1,
                marginRight: "10px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                // whiteSpace: "normal", // Allows the text to wrap to the next line
                wordWrap: "break-word", // Breaks long words if necessary
              }}
            >
              {data?.from}
            </Typography>
          </div>

          <Grid
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography className="normal_normal_600_14_Manrope">
              {data?.createdAt
                ? moment(new Date(data?.createdAt))?.format("DD/MM/YY hh:mm A")
                : "NA"}
            </Typography>
            {/* Transfer email section only for super admin */}
            {userDetails?.role === USER_ROLE?.SUPER_ADMIN && (
              <Tooltip title="Transfer Email">
                <IconButton onClick={() => handleClickEmailTransper(data)}>
                  <TransferWithinAStationIcon />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
        </Grid>
        <Grid item sx={{ mb: 2 }}>
          <Typography className="normal_normal_600_14_Manrope green">
            To
          </Typography>
          {data?.toDeliverability?.map((d) => (
            <EmailWithStatus d={d} />
          ))}
        </Grid>
        {data?.ccDeliverability?.length ? (
          <Grid item sx={{ mb: 2 }}>
            <Typography className="normal_normal_600_14_Manrope green">
              CC
            </Typography>
            {data?.ccDeliverability?.map((d) => (
              <EmailWithStatus d={d} />
            ))}
          </Grid>
        ) : null}
        {data?.bccDeliverability?.length ? (
          <Grid item sx={{ mb: 2 }}>
            <Typography className="normal_normal_600_14_Manrope green">
              BCC
            </Typography>
            {data?.bccDeliverability?.map((d) => (
              <EmailWithStatus d={d} />
            ))}
          </Grid>
        ) : null}

        <Grid item sx={{ mb: 2 }}>
          <Typography className="normal_normal_600_14_Manrope green">
            Subject
          </Typography>
          <Typography
            className=" normal_normal_600_14_Manrope dark_grey"
            component={"span"}
          >
            {data?.subject}
          </Typography>
        </Grid>
        <Grid item>
          <Button
            size="small"
            onClick={() => setShowFullEmail(true)}
            className="normal_normal_600_14_Manrope green"
          >
            READ FULL EMAIL
          </Button>
        </Grid>
      </div>
    </>
  );
};

const SingleNoteView = ({ d, index, clientData, instructionId }) => {
  const dispatch = useDispatch();
  const [selectedDocuments, setSelectedDocuments] = useState(null);
  const [showFullFileName, setShowFullFileName] = useState(false);
  const [showAllDocuments, setShowAllDocuments] = useState(false);

  // Method to read image
  const handleReadImage = async (doc, docIndex = null, isPinned = false) => {
    try {
      let requiredDocIndex = docIndex === null ? 0 : docIndex;
      const response = await dispatch(
        readImage({
          query: {
            filename:
              (!isPinned
                ? doc?.InstructionTaskDocuments[requiredDocIndex]?.documentUrl
                : doc?.LeadClientDocuments[requiredDocIndex]?.documentUrl) ||
              doc?.documentUrl,
          },
        })
      ).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickDownload = async (documentData) => {
    for (const document of documentData) {
      let path = encodeURIComponent(document?.documentUrl);
      let forClient = document?.forClient || null;
      let subType =
        document?.subDocumentType?.name || document?.documentType?.name;
      let version = document?.version;
      if (forClient?.toLowerCase() === "both") {
        forClient = `${clientData?.[0]?.firstName}_${clientData?.[0]?.lastName}_${clientData?.[1]?.firstName}_${clientData?.[1]?.lastName}`;
      }
      const finalUrl = `${process.env.REACT_APP_API_PATH}/file/downloadFinal?path=${path}&filename=${instructionId}_${forClient}_${subType}&version=${version}`;
   
      //window.open(finalUrl, "_blank");
     dispatch(downloadFileThunk(finalUrl));
    }
  };

  // Method to open documents dialog and pass document to component
  const handleClickOpenDocuments = (documents) => {
    // setIsDocuments(true);
    setShowAllDocuments(!showAllDocuments);
    setSelectedDocuments(documents || []);
  };

  //METHOD TO SHOW FULL NAME OF FILE
  const HandleShowfullName = (index) => {
    setShowFullFileName(showFullFileName === index ? null : index);
  };
  let isPinned = Boolean(d?.leadClientId && d?.leadClientId !== null);
  return (
    <>
      {!isPinned ? (
        <Grid>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography className="normal_normal_600_14_Manrope dark_grey">
              {`${d?.notesCreatedBy?.firstName || "NA"} ${
                d?.notesCreatedBy?.lastName || "NA"
              }`}
            </Typography>
            <Typography className="normal_normal_600_14_Manrope">
              {d?.createdAt
                ? moment(new Date(d?.createdAt))?.format("DD/MM/YY hh:mm A")
                : "NA"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              {d?.notes ? (
                typeof d?.notes === "object" ? (
                  Object.keys(d?.notes).map((key) => {
                    return (
                      <Grid className="normal_normal_16_Manrope" key={key}>
                        {d?.notes[key] !== "" ? (
                          <SingleNoteContainer note={d?.notes[key]} />
                        ) : (
                          "NA"
                        )}
                      </Grid>
                    );
                  })
                ) : (
                  <Grid className="normal_normal_16_Manrope">
                    {d?.notes !== "" ? (
                      <SingleNoteContainer note={d?.notes} />
                    ) : (
                      "NA"
                    )}
                  </Grid>
                )
              ) : (
                <Grid className="normal_normal_16_Manrope">N/A</Grid>
              )}
            </Typography>
          </Grid>
          {/* If Document URL available then show attaatchment application only for old notes. */}
          {/* TO SHOW OLD INSTRUCTIONS DOCS  */}
          {d?.documentUrl && d?.documentUrl !== "string" && (
            <Grid
              item
              xs={12}
              mt={1}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{
                  color: "rgb(0, 206, 63)",
                  cursor: "pointer",
                }}
                onClick={() => handleReadImage(d)}
                className="normal_normal_600_14_Manrope"
              >
                Attached Documents
              </Typography>
              <Grid item>
                <IconButton
                  onClick={() =>
                    downloadNotesDocument(d, clientData, null, null, false)
                  }
                >
                  <DownloadIcon />
                </IconButton>
              </Grid>
            </Grid>
          )}

          {d?.InstructionTaskDocuments?.length ? (
            <Grid
              item
              xs={12}
              mt={2}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Typography
                style={{
                  color: "rgb(0, 206, 63)",
                  cursor: "pointer",
                }}
                className="normal_normal_600_14_Manrope"
                onClick={() => handleClickDownload(d?.InstructionTaskDocuments)}
              >
                Download all
              </Typography>
            </Grid>
          ) : null}

          {/* PREVIEW OF 1'ST DOCUMENT TO SHOW NEW INSTUCTION'S DOCS */}
          {d?.InstructionTaskDocuments?.length > 0 &&
          (!d?.documentUrl || d?.documentUrl === "string") &&
          !showAllDocuments ? (
            <Grid
              container
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
              key={index}
            >
              <Grid
                item
                xs={8}
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => HandleShowfullName(index)}
              >
                <Tooltip
                  title={
                    d?.InstructionTaskDocuments[0]?.fileInfo
                      ?.modifiedFileName || ""
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        whiteSpace:
                          showFullFileName === index ? "normal" : "nowrap",
                        overflow:
                          showFullFileName === index ? "visible" : "hidden",
                        textOverflow:
                          showFullFileName === index ? "clip" : "ellipsis",
                      }}
                    >
                      {
                        d?.InstructionTaskDocuments[0]?.fileInfo
                          ?.modifiedFileName
                      }
                    </div>
                  </div>
                </Tooltip>
              </Grid>
              <Grid
                item
                xs={4}
                mt={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton>
                  <VisibilityIcon
                    color="action"
                    onClick={() => handleReadImage(d)}
                  />
                </IconButton>

                <IconButton
                  onClick={() =>
                    downloadNotesDocument(d, clientData, null, null, false)
                  }
                >
                  <DownloadIcon />
                </IconButton>
              </Grid>
            </Grid>
          ) : null}

          {/* PREVIEW OF ALL DOCUMENT TO SHOW NEW INSTUCTION'S DOCS */}
          {d?.InstructionTaskDocuments?.length > 0 &&
          (!d?.documentUrl || d?.documentUrl === "string") &&
          showAllDocuments
            ? d?.InstructionTaskDocuments?.map((doc, docIndex) => {
                return (
                  <Grid
                    container
                    xs={12}
                    sx={{ display: "flex", alignItems: "center" }}
                    key={docIndex}
                  >
                    <Grid
                      item
                      xs={8}
                      key={docIndex}
                      style={{ cursor: "pointer" }}
                      onClick={() => HandleShowfullName(docIndex)}
                    >
                      <Tooltip title={doc?.fileInfo?.modifiedFileName || ""}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              whiteSpace:
                                showFullFileName === docIndex
                                  ? "normal"
                                  : "nowrap",
                              overflow:
                                showFullFileName === docIndex
                                  ? "visible"
                                  : "hidden",
                              textOverflow:
                                showFullFileName === docIndex
                                  ? "clip"
                                  : "ellipsis",
                            }}
                          >
                            {doc?.fileInfo?.modifiedFileName}
                          </div>
                        </div>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      mt={1}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <IconButton>
                        <VisibilityIcon
                          color="action"
                          onClick={() => handleReadImage(d, docIndex)}
                        />
                      </IconButton>

                      <IconButton
                        onClick={() =>
                          downloadNotesDocument(
                            d,
                            clientData,
                            docIndex,
                            null,
                            false
                          )
                        }
                      >
                        <DownloadIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                );
              })
            : null}

          {/* BTN TO SHOW ALL DOCS WHEN NO OF DOCS GREATER THAN 1 */}
          {d?.InstructionTaskDocuments?.length > 1 && (
            <>
              <Grid
                item
                xs={12}
                mt={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Typography
                  style={{
                    color: "rgb(0, 206, 63)",
                    cursor: "pointer",
                  }}
                  className="normal_normal_600_14_Manrope"
                  onClick={() =>
                    handleClickOpenDocuments(d?.InstructionTaskDocuments || [])
                  }
                >
                  Load {showAllDocuments ? "Less" : " More"}
                </Typography>
              </Grid>
            </>
          )}

          {/* <Divider
        sx={{
          marginTop: "1rem",
          border: "0.5px solid lightgrey",
        }}
      /> */}
        </Grid>
      ) : (
        <Grid>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography className="normal_normal_600_14_Manrope dark_grey">
              {`${d?.createdBy?.firstName || "NA"} ${
                d?.createdBy?.lastName || "NA"
              }  `}{" "}
            </Typography>
            <Typography className="normal_normal_600_14_Manrope">
              {d?.createdAt
                ? moment(new Date(d?.createdAt))?.format("DD/MM/YY hh:mm A")
                : "NA"}
            </Typography>
            <Tooltip title="This is a pinned note of client">
              <PushPinIcon
                size="small"
                color="action"
                sx={{ color: "#00ce3f", fontSize: "18px" }}
                onClick={() => {}}
              />
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              {d?.note ? (
                typeof d?.note === "object" ? (
                  Object.keys(d?.note).map((key) => {
                    return (
                      <Grid className="normal_normal_16_Manrope" key={key}>
                        {d?.note[key] !== "" ? (
                          <SingleNoteContainer note={d?.note[key]} />
                        ) : (
                          "N/A"
                        )}
                      </Grid>
                    );
                  })
                ) : (
                  <Grid className="normal_normal_16_Manrope">
                    {d?.note !== "" ? (
                      <SingleNoteContainer note={d?.note} />
                    ) : (
                      "N/A"
                    )}
                  </Grid>
                )
              ) : (
                <Grid className="normal_normal_16_Manrope">N/A</Grid>
              )}
            </Typography>
          </Grid>
          {/* If Document URL available then show attaatchment application only for old notes. */}
          {/* TO SHOW OLD INSTRUCTIONS DOCS  */}
          {d?.documentUrl && d?.documentUrl !== "string" && (
            <Grid
              item
              xs={12}
              mt={1}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{
                  color: "rgb(0, 206, 63)",
                  cursor: "pointer",
                }}
                onClick={() => handleReadImage(d, null, isPinned)}
                className="normal_normal_600_14_Manrope"
              >
                Attached Documents
              </Typography>
              <Grid item>
                <IconButton
                  onClick={() =>
                    downloadNotesDocument(d, clientData, null, null, isPinned)
                  }
                >
                  <DownloadIcon />
                </IconButton>
              </Grid>
            </Grid>
          )}

          {d?.LeadClientDocuments?.length ? (
            <Grid
              item
              xs={12}
              mt={2}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Typography
                style={{
                  color: "rgb(0, 206, 63)",
                  cursor: "pointer",
                }}
                className="normal_normal_600_14_Manrope"
                onClick={() => handleClickDownload(d?.LeadClientDocuments)}
              >
                Download all
              </Typography>
            </Grid>
          ) : null}

          {/* PREVIEW OF 1'ST DOCUMENT TO SHOW NEW INSTUCTION'S DOCS */}
          {d?.LeadClientDocuments?.length > 0 &&
          (!d?.documentUrl || d?.documentUrl === "string") &&
          !showAllDocuments ? (
            <Grid
              container
              xs={12}
              sx={{ display: "flex", alignItems: "center" }}
              key={index}
            >
              <Grid
                item
                xs={8}
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => HandleShowfullName(index)}
              >
                <Tooltip
                  title={
                    d?.LeadClientDocuments[0]?.fileInfo?.modifiedFileName || ""
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        whiteSpace:
                          showFullFileName === index ? "normal" : "nowrap",
                        overflow:
                          showFullFileName === index ? "visible" : "hidden",
                        textOverflow:
                          showFullFileName === index ? "clip" : "ellipsis",
                      }}
                    >
                      {d?.LeadClientDocuments[0]?.fileInfo?.modifiedFileName}
                    </div>
                  </div>
                </Tooltip>
              </Grid>
              <Grid
                item
                xs={4}
                mt={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <IconButton>
                  <VisibilityIcon
                    color="action"
                    onClick={() => handleReadImage(d, null, isPinned)}
                  />
                </IconButton>

                <IconButton
                  onClick={() =>
                    downloadNotesDocument(d, clientData, null, null, isPinned)
                  }
                >
                  <DownloadIcon />
                </IconButton>
              </Grid>
            </Grid>
          ) : null}

          {/* PREVIEW OF ALL DOCUMENT TO SHOW NEW INSTUCTION'S DOCS */}
          {d?.LeadClientDocuments?.length > 0 &&
          (!d?.documentUrl || d?.documentUrl === "string") &&
          showAllDocuments
            ? d?.LeadClientDocuments?.map((doc, docIndex) => {
                return (
                  <Grid
                    container
                    xs={12}
                    sx={{ display: "flex", alignItems: "center" }}
                    key={docIndex}
                  >
                    <Grid
                      item
                      xs={8}
                      key={docIndex}
                      style={{ cursor: "pointer" }}
                      onClick={() => HandleShowfullName(docIndex)}
                    >
                      <Tooltip title={doc?.fileInfo?.modifiedFileName || ""}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              whiteSpace:
                                showFullFileName === docIndex
                                  ? "normal"
                                  : "nowrap",
                              overflow:
                                showFullFileName === docIndex
                                  ? "visible"
                                  : "hidden",
                              textOverflow:
                                showFullFileName === docIndex
                                  ? "clip"
                                  : "ellipsis",
                            }}
                          >
                            {doc?.fileInfo?.modifiedFileName}
                          </div>
                        </div>
                      </Tooltip>
                    </Grid>
                    <Grid
                      item
                      xs={4}
                      mt={1}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <IconButton>
                        <VisibilityIcon
                          color="action"
                          onClick={() => handleReadImage(d, docIndex, isPinned)}
                        />
                      </IconButton>

                      <IconButton
                        onClick={() =>
                          downloadNotesDocument(
                            d,
                            clientData,
                            docIndex,
                            null,
                            isPinned
                          )
                        }
                      >
                        <DownloadIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                );
              })
            : null}

          {/* BTN TO SHOW ALL DOCS WHEN NO OF DOCS GREATER THAN 1 */}
          {d?.LeadClientDocuments?.length > 1 && (
            <>
              <Grid
                item
                xs={12}
                mt={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Typography
                  style={{
                    color: "rgb(0, 206, 63)",
                    cursor: "pointer",
                  }}
                  className="normal_normal_600_14_Manrope"
                  onClick={() =>
                    handleClickOpenDocuments(d?.LeadClientDocuments || [])
                  }
                >
                  Load {showAllDocuments ? "Less" : " More"}
                </Typography>
              </Grid>
            </>
          )}

          {/* <Divider
            sx={{
              marginTop: "1rem",
              border: "0.5px solid lightgrey",
            }}
          /> */}
        </Grid>
      )}
    </>
  );
};
